export class mdlDriverNCDDetailsCompRenewal {
    public DriverType: string;
    public DriverId: string;
    public DriverGender: string;
    public DriverDOB: Date | string;
    public NCD_ClaimFreeYears: number;
    public NCD_RefNo: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlDriverNCDDetailsCompRenewal.ts